import { css, styled } from "../../../styles";

// Components

export const Header = styled("div", {
  width: "100%",
  height: "62px",

  position: "absolute",

  backgroundColor: "var(--colors-builder-banner-background)",
  padding: "0 40px 0 68px",
  boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.16)",

  display: "flex",
  alignItems: "center",

  p: {
    color: "$white",
    fontSize: "16px",
    fontWeight: "00",
    lineHeight: "22px",
  },

  variants: {
    isClinicianForm: {
      true: {
        justifyContent: "center",
        zIndex: 1,
      },
    },
  },
});

export const ButtonsContainer = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "12px",

  position: "absolute",
  right: "40px",
});

export const CancelButton = styled("div", {
  minWidth: "110px",
  width: "max-content",
  whiteSpace: "nowrap",
  height: "38px",

  padding: "0px 40px",
  borderRadius: "20px",

  backgroundColor: "var(--colors-builder-button-tertiary-background)",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "22px",
  color: "var(--colors-builder-button-tertiary-text)",

  cursor: "pointer",

  "&:hover": {
    backgroundColor: "var(--colors-builder-button-tertiary-hover-background)",
  },

  "&:focus-visible": {
    outline:
      "2px solid var(--colors-builder-button-tertiary-focus-border) !important",
  },
});

export const BuilderLayoutContainer = styled("div", {
  width: "100vw",
  height: "100vh",
  position: "relative",
  backgroundColor: "$gray-20",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  variants: {
    hasDashboardLayout: {
      true: {
        marginTop: "-62px",
        zIndex: 2001,
      },
    },
  },
});

export const SectionsHeader = styled("div", {
  width: "100%",
  height: "62px",
  marginTop: "62px",
  backgroundColor: "$gray-20",
  padding: "0 40px 0 68px",
  boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.16)",
  zIndex: 100,
});

export const SectionsContainer = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "42px",
});

export const SectionButton = styled("div", {
  color: "$gray-90",

  fontFamily: "$openSans",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "22px",
  marginTop: "20px",

  cursor: "pointer",

  "&:hover": {
    div: {
      backgroundColor: "var(--colors-builder-section-button-hover-underline)",
    },
  },

  "&:focus": {
    outline: "none",

    div: {
      backgroundColor: "var(--colors-builder-section-button-focus-underline)",
    },
  },
});

export const Underline = styled("div", {
  width: "100%",
  height: "5px",

  borderRadius: "2px",
  marginTop: "15px",

  variants: {
    isActive: {
      true: {
        backgroundColor:
          "var(--colors-builder-section-button-selected-underline) !important",
      },
    },
  },
});

// CSS

export const purpleButton = css({
  button: {
    backgroundColor:
      "var(--colors-builder-button-primary-background) !important",
    borderColor: "var(--colors-builder-button-primary-border) !important",

    p: {
      color: "var(--colors-builder-button-primary-text) !important",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "22px",
    },

    "&:hover": {
      backgroundColor:
        "var(--colors-builder-button-primary-hover-background) !important",
    },

    "&:focus-visible": {
      outline:
        "2px solid var(--colors-builder-button-primary-focus-border) !important",
    },
  },
});

export const spinCss = css({
  backgroundColor: "white !important",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  ".ant-spin-dot": {
    ".ant-spin-dot-item": {
      backgroundColor: "var(--colors-portal-loading-state-color)",
    },
  },
});

export const whiteButton = css({
  button: {
    backgroundColor:
      "var(--colors-builder-button-secondary-background) !important",
    borderColor: "var(--colors-builder-button-secondary-border) !important",

    p: {
      color: "var(--colors-builder-button-secondary-text) !important",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "22px",
    },

    "&:hover": {
      backgroundColor:
        "var(--colors-builder-button-secondary-hover-background) !important",
    },

    "&:focus-visible": {
      outline:
        "2px solid var(--colors-builder-button-secondary-focus-border) !important",
    },
  },
});
